import { useTranslation } from '../../../../../utils/useTranslation';
import { IconChecked } from '../../../../icon/IconChecked';
import { IconChevron } from '../../../../icon/IconChevron';
import { Button } from '../../../../input/Button';
import { Menu, MenuItem } from '../../../../navigation/Menu';
import { Typography } from '../../../../typography/Typography';
import { ContentPromotionLoginContentProps } from './types';

export const ContentPromotionLoginContent: React.FC<ContentPromotionLoginContentProps> = ({
    options,
    value,
    onChange,
}) => {
    const t = useTranslation();

    if (!options.length) {
        return (
            <>
                <Typography variant="body" mt={2}>
                    {t('Не удалось загрузить список аккаунтов в директе.')}
                </Typography>
                {value ? (
                    <Typography variant="body">{t(`\nБудет использован: ${value}`)}</Typography>
                ) : null}
            </>
        );
    }

    return (
        <Menu
            mt={2}
            trigger={
                <Button spacing={0.25} variant="filled" color="secondary" size="m">
                    <Typography variant="caption">{value ?? t('выбрать аккаунт')}</Typography>
                    <IconChevron size={20} />
                </Button>
            }
        >
            {options.map((option) => (
                <MenuItem
                    key={option}
                    spacing={1}
                    direction="row"
                    justifyContent="space-between"
                    onClick={() => onChange(option)}
                >
                    <Typography variant="body" noWrap>
                        {option}
                    </Typography>
                    <IconChecked
                        size={20}
                        color={value === option ? 'var(--color-primary)' : 'transparent'}
                    />
                </MenuItem>
            ))}
        </Menu>
    );
};
